const ReportStyle = {
    backButton: {
        position: 'absolute',
        right: '-5px',
        top: '20px',
        width: '38px',
        minWidth: '38px !important',
        height: '38px',
        padding: '11px',
        borderRadius: '50% !important',
        boxShadow: '-2px -1px 6px -2px #909090',
        backgroundColor: '#f5f5f5 !important',
        zIndex: '1',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    rectangle: {
        width: '18px',
        height: '4px',
        margin: '2px 2px 26px',
        backgroundColor: 'var(--light-gray-3)',
    },
    smartImg: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // position:'absolute',
        // width:'100%',
        // top:'30px',
        zIndex: '100',
        marginTop: '22px'
    },
    ButtonStyle: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        width: '72px',
        height: '48px',
        boxShadow: '-2px -2px 4px #FFFFFF, -4px 4px 10px rgba(0, 0, 0, 0.15)',
        border: 'solid 1px #ffffff !important',
        backgroundColor: '#FFFFFF !important',
        borderRadius: '16px !important',
        textAlign: 'center',
        // margin:"auto !important",
        // marginTop:"30px !important",
    },
    ChosenButtonStyle: {
        boxShadow: '-6px 6px 10px rgba(0, 0, 0, 0.06), 2px -2px 4px #FFFFFF, inset -6px -6px 12px #FFFFFF, inset 10px 10px 6px rgba(174, 174, 192, 0.15) ',
    },
    ButtonLabel: {
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        color: '#707070 !important',
    },
    ChosenButtonLabel: {
        color: '#753cbe !important'

    },
    tabContainer: {
        // height: '50px',
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
        // color: '#753cbe !important',
        // fontWeight: '700',
        // fontFamily: 'Kalameh',
    },
    tabSelectedReport: {
        backgroundColor: '#ffffff',
        borderRadius: '14px 0 0',
        boxShadow: ' 0 -5px 5px 0 rgba(0, 0, 0, 0.1)'
    },
    tabSelectedLogBook: {
        backgroundColor: '#ffffff',
        borderRadius: '14px 0 0 0',
        boxShadow: ' 0 -5px 5px 0 rgba(0, 0, 0, 0.1)'
    },
    tabName: {
        fontFamily: 'Kalameh',
        fontSize: '18px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        color: '#707070 !important',
        textAlign: 'center',
    },
    tabNameSelected: {
        color: '#753cbe !important'
    },
    TextStyle: {
        fontSize: '16px',
        color: '#1fb9ee',
    },
    empty: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4e4e4e',
        marginTop: 0,
        marginBottom: '2rem'

    },
    noDataContainer: {
        // backgroundColor: '#ffffff',
        paddingTop: '50px',
        paddingBottom: '50px'
    },
    noData: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    noDataText: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#753cbe',
        marginTop: 0,
        textAlign: 'center'
    },
    SMBG: {
        display: 'flex',
        justifyContent: 'center',
        // width: '149px',
        height: ' 25px',
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        textAlign: 'center',
        color: '#753cbe',
        padding: '20px 0 40px'
    },
    divider: {
        margin: '10px 25px !important',
        padding: '0 20px',
    },
    SmbgSpan: {
        fontFamily: 'Kalameh',
        color: '#4E4E4E',
        fontSize: '14px',
        // paddingLeft: '30px'
    },
    SmbgSpanNumber: {
        fontFamily: 'Kalameh',
        color: '#753cbe',
        fontSize: '18px',
        fontWeight: '700'
    },
    dateSpanNumber: {
        fontFamily: 'Kalameh',
        color: '#753cbe',
        fontSize: '16px',
        fontWeight: '700'
    },
    container: {
        padding: '0 30px 10px 30px ',
    },
    Question: {
        color: '#753cbe',
        width: '322px',
        height: '260px',
        margin: '24px 0 0 !important',
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '1px'

    },
    QuestionChild1: {
        color: '#4e4e4e',

    },
    HypoTitle: {
        display: 'flex',
        justifyContent: 'center',
        height: ' 40px',
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 1px',
        textAlign: 'center',
        color: '#d81d5d',
        padding: ' 0 25px 25px 25px'
    },
    Hypo: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: '30px',
        margin: '0 10px 10px 10px',
        padding: '25px 21px',
        borderRadius: '16px',
        border: 'solid 1px #d81d5d',
        backgroundColor: '#F5F5F5',
        boxShadow: '-8px -8px 25px 0 #FFFFFF',
    },
    HypoRate: {
        display: 'flex',
        justifyContent: "center",
        alignItems: 'center',
        fontFamily: 'Kalameh',
        fontSize: '25px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#d81d5d',
    },
    HypoDate: {
        display: 'flex',
        justifyContent: "left",
        alignItems: 'center',
        fontFamily: 'Kalameh',
        fontSize: '14px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#707070',
    },
    HypoHour: {
        display: 'flex',
        justifyContent: "center",
        alignItems: 'center',
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#753cbe',
    },
    HypoIcon: {
        // display:'flex',
        // justifyContent:"center",
        // alignItems:'center',
        color: "#4e4e4e",
        fontSize: '1.3rem'
    },
    sickName: {
        color: '#707070',
        fontFamily: 'Kalameh',
        fontSize: '20px',
        fontWeight: 'bold',
        margin: 0

    },
    expandedSickName: {
        color: '#753cbe',
        fontFamily: 'Kalameh',
        fontSize: '20px',
        fontWeight: 'bold',
        margin: 0
    },
    sickInfo: {
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#753cbe !important',
        textAlign: 'right'
    },
    sickTitle: {
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#707070 !important',
    },
    timeIconBlue: {
        color: '#1fb9ee !important',
        fontSize: '16px !important'
    },
    timeIconPurple: {
        color: '#753cbe !important',
        fontSize: '16px !important',
    },
    prepost: {
        fontSize: '12px',
        color: '#707070',
        fontFamily: 'Kalameh',
        margin: 0
    },
    Hour: {
        display: 'flex',
        justifyContent: "left",
        alignItems: 'center',
        fontFamily: 'Kalameh',
        fontSize: '15px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#753cbe',
    },
    ampm: {
        fontSize: '12px !important',
        marginRight: '5px !important'
    },
    EditeButtonStyle: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        height: '48px',
        boxShadow: '-2px 2px 0px -1px rgba(172, 172, 172, 0.5), -4px -4px 5px -2px #ffffff',
        backgroundColor: '#f5f5f5',
        textAlign: 'center',
        right: 0,
    },
    EditeButtonLabel: {
        fontFamily: 'Kalameh',
        fontSize: '14px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        color: '#707070 !important',
    },
    ChildChart: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // borderRight: '1px solid #f0f0f0',
        // padding: '5px',
        // backgroundColor:'red'
    },
    TextChart: {
        margin: '0',
        fontSize: '10px',
        fontWeight: 'bold',
        color: '#707070',
        fontFamily: 'Kalameh'
    },
    periodSelection: {
        boxShadow: '-6px 6px 10px rgba(0, 0, 0, 0.06), 2px -2px 4px #FFFFFF, inset -6px -6px 12px #FFFFFF, inset -10px 10px 6px rgba(174, 174, 192, 0.15) !important',
        color: '#753cbe !important',

    },
    notSelected:{
        color: "#707070 !important",

    },
    periodBtns: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        width: '72px',
        height: '48px',
        boxShadow: '-2px -2px 4px #FFFFFF, -4px 4px 10px rgba(0, 0, 0, 0.15)',
        border: 'solid 1px #ffffff !important',
        backgroundColor: '#FFFFFF !important',
        borderRadius: '16px !important',
        textAlign: 'center',
        fontFamily: "dana !important",
        fontWeight: '700 !important'
    },
    activeReportTabStyle: {
        backgroundColor: '#ffffff',
        borderRadius: '14px 0 0',
        boxShadow: ' 0 -5px 5px 0 rgba(0, 0, 0, 0.1)'
    },
    activeLogbookTabStyle: {
        backgroundColor: '#ffffff',
        borderRadius: '14px 0 0 0',
        boxShadow: ' 0 -5px 5px 0 rgba(0, 0, 0, 0.1)'
    },
    tabContainerStyle: {
        height: '50px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#753cbe !important',
        fontWeight: '700',
        fontFamily: 'Kalameh',
    },
    titleChoices:{
        fontWeight: '400',
        fontFamily: 'Kalameh',
        fontSize:'10px',
        paddingRight:'2px',
        textTransform:'uppercase',
        color:'#707070',
    },
    boldTitleChoices:{
        fontWeight: '700',
        fontFamily: 'Kalameh',
        fontSize:'14px',
        color:'#707070',
    },
    filterDaysContainer:{
        display:'flex',
        alignItems:'center',
        paddingTop:'20px',
        marginBottom: '4px',
        padding:'17px'
    },
    filterDaysText:{
        display:'flex',
        justifyContent:'start',
        alignItems:'center'
    },
    labelContainer: {
        width: '16px !important',
        height: '16px !important',
        fontSize: '14px !important',
        borderRadius: "4px !important",
        marginLeft: '4px !important'
    },
};

export default ReportStyle;